import { Typography } from '@mui/material';
import { Dialog } from '@components';
import { Dispatch, SetStateAction } from 'react';
import { deleteOperationActivity, OperationActivity } from '../../../../networkRequest/operationsService';
import { useUser } from '../../../../hooks/useUser';

interface DeleteActivityDialogProps {
  open: boolean;
  onClose: Dispatch<SetStateAction<boolean>>;
  onDeleteActivity: () => Promise<void>;
  selectedActivity: OperationActivity | null;
  setSelectedActivity: Dispatch<SetStateAction<OperationActivity | null>>;
  setError: Dispatch<SetStateAction<string | null>>;
}

const DeleteActivityDialog = ({
  open,
  onClose,
  onDeleteActivity,
  selectedActivity,
  setSelectedActivity,
  setError,
}: DeleteActivityDialogProps) => {
  const { user } = useUser();

  const handleCancel = () => {
    setSelectedActivity(null);
    onClose(false);
  };

  const handleDelete = async () => {
    if (!selectedActivity || !user) {
      return;
    }

    const { error } = await deleteOperationActivity({
      accessToken: user.accessToken,
      activityId: selectedActivity.id
    });

    if (error) {
      setError(error);
      return;
    }

    onDeleteActivity();
    setSelectedActivity(null);
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleCancel}
      showClose={false}
      primaryButtonText='Delete'
      primaryButtonAction={handleDelete}
      secondaryButtonText='Cancel'
      fullWidth={false}
    >
      <Typography variant='h5'>Delete Activity?</Typography>
      <Typography sx={{
        mt: '8px'
      }}>This activity will be removed from the list.</Typography>
    </Dialog>
  );
};

export default DeleteActivityDialog;